const isMobile = function() {
  const sUserAgent = navigator.userAgent.toLowerCase()
  if (/ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(sUserAgent) || document.documentElement.clientWidth < 500) {
    // 移动端
    return true
  } else {
    // PC端
    return false
  }
}
// 设置 rem 函数
const setRem = function(isSpecial) {
  let cssText = ''
  if (isSpecial || window.location.pathname.includes('login') || window.location.pathname.includes('welcome')) {
    let deviceWidth
    const bodywidth = document.documentElement.clientWidth
    deviceWidth = bodywidth > 1242 ? 1242 : bodywidth
    deviceWidth = bodywidth < 310 ? 310 : bodywidth
    cssText = 'font-size:' + deviceWidth / 3.75 + 'px;min-width: auto;'
  }
  document.getElementsByTagName('html')[0].style.cssText = cssText
}

/**
 * @description: 时间格式化, 把时间戳、时间字符串、Date对象转换为字符串
 * @param {Object, String, Number} date 需要转换的时间
 * @param {String} format 转换后的格式, 默认是: yyyy-MM-dd hh:mm:ss
 * @return {String} 转换后的时间, 如: 1970-01-01 00:00:00
 */
const formatDate = (date, format) => {
  if (!date) { return '-' }
  if (date === '-' || date === '--') {
    return date
  }
  if (typeof date === 'string') {
    date = date.replace(/-/g, '/')
  }
  date = new Date(date)
  const paddNum = function(num) {
    num += ''
    return num.replace(/^(\d)$/, '0$1')
  }
  // 指定格式字符
  const cfg = {
    yyyy: date.getFullYear(), // 年 : 4位
    yy: date.getFullYear().toString().substring(2), // 年 : 2位
    M: date.getMonth() + 1, // 月 : 如果1位的时候不补0
    MM: paddNum(date.getMonth() + 1), // 月 : 如果1位的时候补0
    d: date.getDate(), // 日 : 如果1位的时候不补0=
    dd: paddNum(date.getDate()), // 日 : 如果1位的时候补0
    hh: paddNum(date.getHours()), // 时
    mm: paddNum(date.getMinutes()), // 分
    ss: paddNum(date.getSeconds()) // 秒
  }
  format || (format = 'yyyy-MM-dd hh:mm:ss')
  return format.replace(/([a-z])(\1)*/ig, function(m) {
    return cfg[m]
  })
}
export default {
  isMobile,
  setRem,
  formatDate
}
